import http from '../../helpers/APIHelper';

export const getAdminCirbChildGridDataAction = (token, loggerInfo, sigPrefId) => () => {
  const postBody = {
    first: 0,
    isMetaRequired: true,
    size: -1
  };
  return http.postWithToken(
    `regulatory-data-service/${process.env.REACT_APP_PERSON_API_VERSION}/admin/sigprefid/${sigPrefId}/siteprefsdetails`,
    token,
    postBody,
    loggerInfo
  );
};

export const updateAdminCirbParentRecordAction = (token, loggerInfo, payload) => () => http.putWithToken(
  `regulatory-data-service/${process.env.REACT_APP_PERSON_API_VERSION}/admin/siteprefsmain`,
  token,
  JSON.stringify(payload),
  loggerInfo
);

export const updateAdminCirbChildRecordAction = (token, loggerInfo, sigPrefId, payload) => () => http.putWithToken(
  `regulatory-data-service/${process.env.REACT_APP_PERSON_API_VERSION}/admin/sigprefid/${sigPrefId}/siteprefsdetails`,
  token,
  JSON.stringify(payload),
  loggerInfo
);

export const getAdminCirbInstitutionApi = (token, loggerInfo, siteCtepIdLike) => () => http.getWithToken(
  `irost-data-service/${process.env.REACT_APP_PERSON_API_VERSION}/sites/number/${siteCtepIdLike}/status/Y/tree`,
  token,
  loggerInfo
);
